// extracted by mini-css-extract-plugin
export default {"body":"body_body__g9O6g","cell":"body_cell__PdJ+h","load-button":"body_load-button__WeiBM"};